export const DATASET = 'Dataset';
export const PIPELINE = 'Pipeline';
export const ML_PACKAGE = 'ML Package';
